import { basename } from './config';
export const getPreviewUrl = (codeHash, componentId) => `${basename}/_preview/${codeHash}${componentId ? `/${componentId}` : ''}/`;
//# sourceMappingURL=preview-url.js.map